<div class="background" [ngStyle]="style"></div>